// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5f1f87801c3e4c605b67551b8fb23825","container":"be885963ba4560e5a757811ad64a488c","page_current":"efc0ddf6c0b7823cf173ba2d6179b52a"};